import './App.css';

import "bootstrap/dist/css/bootstrap.min.css"
import { Routes, Route } from "react-router-dom"

import Dashboard from "./components/Dashboard/Dashboard";
import Projects from "./components/Dashboard/Projects"
import Users from "./components/Dashboard/Users";

import SignInPage from "./components/Auth/SignInPage";
import { UserAuthContextProvider } from "./context/UserAuthContext";
import React from "react";
import ProtectedRoute from "./context/ProtectedRoute";
import RoleRoute from "./context/RoleRoute";

import AssociationRegisterPage from "./components/Association/RegisterPage";
import AssociationHome from "./components/Association/PortalHome";
import AssociationProjectAdd from "./components/Association/ProjectAddPage";
import AssociationProjectDetails from "./components/Association/ProjectDetailsPage";
import AssociationProfile from "./components/Association/ProfilePage";

import EngineerRegisterPage from "./components/Engineer/EngineerRegisterPage";
import EngineerHome from "./components/Engineer/EngineerHome";
import EngineerProjectDetails from "./components/Engineer/EngineerProjectDetails";
import EngineerProfile from "./components/Engineer/EngineerProfile";

import Home from "./components/Home";
import Associations from "./components/Dashboard/Associations";

import Privacy from './components/privacy';

import FAQPage from './components/LandingPage/FAQPage';
import AboutUsPage from './components/LandingPage/AboutUsPage';
import PlatformPage from './components/LandingPage/PlatformPage';
import ExamplesPage from './components/LandingPage/ExamplesPage';

function App() {

    return (



        <UserAuthContextProvider>
            <Routes>
                <Route path={"/"} element={<Home />} />
                <Route path={"/login"} element={<SignInPage />} />
                <Route path="/faqs" element={<FAQPage />} />
                <Route path="/sobre" element={<AboutUsPage />} />
                <Route path="/plataforma" element={<PlatformPage />} />
                <Route path="/exemplos" element={<ExamplesPage />} />



                {/* Nota: "Component={Privacy}" (o estilo original) também funciona no
                    react-router 6.21 instalado — as duas formas são equivalentes.
                    Mantido "element" para consistência com as restantes rotas. */}
                <Route path="/privacy" element={<Privacy />} />

                {/* Portal de Associações (Fase 1) */}
                <Route path="/registo/associacao" element={<AssociationRegisterPage />} />
                <Route path="/app/associacao" element={
                    <RoleRoute roles={["association"]}>
                        <AssociationHome />
                    </RoleRoute>
                } />
                <Route path="/app/associacao/projetos/novo" element={
                    <RoleRoute roles={["association"]}>
                        <AssociationProjectAdd />
                    </RoleRoute>
                } />
                <Route path="/app/associacao/projetos/:id" element={
                    <RoleRoute roles={["association"]}>
                        <AssociationProjectDetails />
                    </RoleRoute>
                } />
                <Route path="/app/associacao/perfil" element={
                    <RoleRoute roles={["association"]}>
                        <AssociationProfile />
                    </RoleRoute>
                } />

                {/* Portal de Engenheiros (Fase 2) */}
                <Route path="/registo/engenheiro" element={<EngineerRegisterPage />} />
                <Route path="/app/engenheiro" element={
                    <RoleRoute roles={["engineer"]}>
                        <EngineerHome />
                    </RoleRoute>
                } />
                <Route path="/app/engenheiro/projetos/:id" element={
                    <RoleRoute roles={["engineer"]}>
                        <EngineerProjectDetails />
                    </RoleRoute>
                } />
                <Route path="/app/engenheiro/perfil" element={
                    <RoleRoute roles={["engineer"]}>
                        <EngineerProfile />
                    </RoleRoute>
                } />

                {/* Dashboard — só administradores.
                    ProtectedRoute exige sessão; RoleRoute exige o papel "admin"
                    (sem esta guarda, qualquer conta logada entrava no dashboard). */}
                <Route exact path={"/dashboard"} element={
                    <ProtectedRoute>
                        <RoleRoute roles={["admin"]}>
                            <Dashboard />
                        </RoleRoute>
                    </ProtectedRoute>
                } />
                <Route exact path={"/dashboard/users"} element={
                    <ProtectedRoute>
                        <RoleRoute roles={["admin"]}>
                            <Users />
                        </RoleRoute>
                    </ProtectedRoute>
                } />
                <Route exact path={"/dashboard/projects"} element={
                    <ProtectedRoute>
                        <RoleRoute roles={["admin"]}>
                            <Projects />
                        </RoleRoute>
                    </ProtectedRoute>
                } />
                <Route exact path={"/dashboard/associations"} element={
                    <ProtectedRoute>
                        <RoleRoute roles={["admin"]}>
                            <Associations />
                        </RoleRoute>
                    </ProtectedRoute>
                } />



            </Routes>
        </UserAuthContextProvider>



    );
}

export default App;
